import { IUser } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { EAddressField } from "@rentiohq/shared-frontend/dist/utils/address.utils";
import { EField } from "./schema.profilePersonal.types";

export const getInitialValues = (user: IUser) => {
  const { personalContact } = user;
  if (!personalContact) {
    return;
  }

  return {
    [EField.FirstName]: user.firstname,
    [EField.LastName]: user.lastname,
    [EField.Email]: user.unverifiedEmail || user.email,
    [EField.MobileNumber]: user.unverifiedPhone || user.phone,
    [EField.Language]: user.locale,
    [EAddressField.Street]: personalContact.street,
    [EAddressField.Number]: personalContact.number,
    [EAddressField.Box]: personalContact.box,
    [EAddressField.Zip]: personalContact.zip,
    [EAddressField.City]: personalContact.city,
    [EAddressField.State]: personalContact.state,
    [EAddressField.Country]: personalContact.countryId,
  };
};
